module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-tile-repeater"
  }, _vm._l((_vm.props), function(tile, i) {
    return _c('div', {
      key: i,
      staticClass: "custom-tile-repeater__tile"
    }, [_c('div', {
      staticClass: "custom-tile-repeater__image-box"
    }, [_vm._t("image", null, {
      "content": tile.image
    })], 2), (tile.button.href) ? _c('router-link', {
      staticClass: "custom-tile-repeater__textbox",
      attrs: {
        "to": tile.button.href
      }
    }, [_vm._t("title", null, {
      "content": tile.title
    }), (tile.button.href) ? _c('router-link', {
      staticClass: "custom-tile-repeater__link",
      attrs: {
        "to": tile.button.href
      },
      domProps: {
        "innerHTML": _vm._s(tile.button.label)
      }
    }) : _vm._e()], 2) : _vm._e(), (!tile.button.href) ? _c('div', {
      staticClass: "custom-tile-repeater__textbox"
    }, [_vm._t("title", null, {
      "content": tile.title
    }), _c('div', {
      staticClass: "custom-tile-repeater__link"
    }, [_c('div', {
      staticClass: "custom-tile-repeater__appointment-container"
    }, [_c('div', {
      staticClass: "custom-tile-repeater__appointment-link"
    }, [_c('a', {
      attrs: {
        "href": "https://www.anywheredolphin.com/forms/lakenonaorthodontics.com/-fikhon8YkWCNuinG1vkCA",
        "target": "_blank"
      },
      domProps: {
        "innerHTML": _vm._s("Lake Nona Schedule Online")
      }
    })]), _c('div', {
      staticClass: "custom-tile-repeater__appointment-link"
    }, [_c('FunctionButton2', {
      attrs: {
        "content": _vm.button,
        "function1": _vm.openModal
      }
    }, [_vm._v("Email Us")])], 1), _c('div', {
      staticClass: "custom-tile-repeater__appointment-link"
    }, [_c('a', {
      attrs: {
        "href": "tel:+14076271187"
      },
      domProps: {
        "innerHTML": _vm._s("Call Us")
      }
    })])])])], 2) : _vm._e()], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68db5311","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-tile-repeater/custom-tile-repeater.pug
// module id = 598
// module chunks = 1